export enum QuestionnaireElementType {
  Text = 'Text',
  Notes = 'Notes',
  RadioGroup = 'RadioGroup',
  Checkbox = 'Checkbox',
  Address = 'Address',
  TimeWindow = 'TimeWindow'
}
